'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".DeliveryHistory-module_container__5-EpU{width:100%}";
var styles = {"container":"DeliveryHistory-module_container__5-EpU"};
styleInject["default"](css_248z, '78aca176-cce7-4e85-aca5-0899ba4ded7b');

exports["default"] = styles;
